import { SetStateAction, useCallback } from 'react'
import { ShippingServiceExtended } from '../..'
import RangeTable, { RangeTableDataDict } from '../../../../../../../../../../baseComponents/RangeTable'
import { priceRangeTypesInversed } from '@teinor/erp/types/company/config/shipping/shippingCompany/shippingService'
import { getCurrencySymbol } from '../../../../../../../../../../utils/globals/price'

interface TableShippingRatesProps extends TableShippingRatesLogicProps {
    dataService: ShippingServiceExtended
    setDataService: React.Dispatch<SetStateAction<ShippingServiceExtended | null>>
    EditComponent: React.ElementType
    editComponentProps: any
}

const TableShippingRates: React.FC<TableShippingRatesProps> = ({ dataService, setDataService, EditComponent, editComponentProps }) => {
    const { onChangeRanges, onChangeRangeRow } = useTableShippingRatesLogic({setDataService})
    const { priceRangeType, ranges, CurrencyId } = dataService
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    return (
        <RangeTable tags={{ header: parseInt(String(priceRangeType)) === priceRangeTypesInversed['money'] ? CurrencySymbol : 'kg', rows: CurrencySymbol }} rangeData={dataService.dictShippingRates} {...{ ranges, onChangeRanges, onChangeRangeRow, EditComponent, editComponentProps}} />
    )
}

interface TableShippingRatesLogicProps {
    setDataService: React.Dispatch<SetStateAction<ShippingServiceExtended | null>>
}

const useTableShippingRatesLogic = ({ setDataService }: TableShippingRatesLogicProps) => {
    const onChangeRanges = useCallback((ranges: number[]) => {
        setDataService((old) => {
            if(old){
                return { ...old, ranges }
            }
            return null
        })
    }, [setDataService])

    const onChangeRangeRow = useCallback((rangeData: RangeTableDataDict) => {
        setDataService((old) => {
            if(old){
                return { ...old, 'dictShippingRates': rangeData }
            }
            return null
        })
    }, [setDataService])

    return { onChangeRanges, onChangeRangeRow }
}


export default TableShippingRates